import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Slider from "react-slick"

import "./section-game.scss"
import Button from "../../../shared/components/atoms/button/button"

const SectionGame = ({ contentInfo }) => {
  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-game-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-game-prev" onClick={onClick} />
  }
  var settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "10px",
    variableWidth: true,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <section className="f-section-game-container">
      <div className="f-game-title-container">
        <TitleTab
          className="f-TitleTab f-TitleTab-pink"
          title="Juega y diviértete"
        />
      </div>
      {/* <div className="f-slider-game">
            </div> */}
      <Slider
        {...settings}
        className={
          contentInfo && contentInfo.length === 1
            ? "f-carousel-game--oneitem"
            : "f-carousel-game"
        }
      >
        {contentInfo.map((info, index) => (
          <div key={index}>
            <div className="f-carousel-game-item">
              <img
                className="ff-carousel-game-item-imagen"
                alt={info.metaImagen.description}
                src={info.metaImagen.file.url}
              />
              <h3>{info.metaTitulo}</h3>
              <a href={"magazin/juegos/" + info.slug}>
                <Button className="f-btn primary-blue short" title="Jugar" />
              </a>
            </div>
          </div>
        ))}
      </Slider>
      {/* <div className="f-buttons-game-container">
                
            </div> */}
    </section>
  )
}

export default SectionGame
